import { createSelector, Selector } from '@reduxjs/toolkit';
import { profileActions } from 'common/modules/ReactShared';
import { IRequestingState } from './model';
import { tSharedAppState, tSharedStore } from '../types';
import { selectShared } from '../sharedSelectors';

const selectRequesting: Selector<tSharedAppState, tSharedStore['requesting']> =
  createSelector([selectShared], (shared) => shared.requesting);

const selectProfileRequesting: Selector<tSharedAppState, boolean> = createSelector(
  [selectRequesting],
  (requesting) => !!requesting[profileActions.getProfile.typePrefix]
);

const selectHasRequestingActions = (
  actionsToRequest: string[]
): Selector<tSharedAppState, boolean> =>
  createSelector([selectRequesting], (requesting: IRequestingState) => {
    return actionsToRequest.some((actionName) => requesting && requesting[actionName]);
  });

export default { selectRequesting, selectProfileRequesting, selectHasRequestingActions };
